import { AscReportDetailsContainer } from './containers'
import { role } from '@/utilities/userRoles'

const reportsRouter = {
  icon: 'mdi-file',
  path: '/reportDetails/reportid/:reportId/tail/:tailNumber',
  name: 'Report Details',
  component: AscReportDetailsContainer,
  display: false,
  meta: {
    requiresEccn: true,
    requiresRole: role.acmfUser,
    breadcrumbs: [
      {
        text: 'Home',
        to: '/',
      },
      {
        text: 'ACMF Reports',
        to: '/reports',
      },
      {
        text: route => ` ${route.params.reportId} - ${route.params.tailNumber}`,
      },
    ],
  },
  props: route => ({
    reportId: isNaN(route.params.reportId) ? 0 : Number(route.params.reportId),
    tailNumber: route.params.tailNumber,
  }),
  children: [],
}

export default reportsRouter
